import React, { ReactNode, useRef } from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { isNil } from 'ramda';
import { ColumnStyle } from '~common/components/column.component';
import { ButtonProps } from '~common/components/button/button.component';
import { DropdownSelectMenuDesktop } from '~web/view/components/ui/form/dropdown-select-menu-desktop.component';
import { DropdownSelectMenuMobile } from '~web/view/components/ui/form/dropdown-select-menu-mobile.component';

export interface DropdownSelectMenuOption {
  value: string;
  name: string;
  /*
  Note that a decoration is only possible for the desktop menu - if providing a renderDecoration here,
  the desktop dropdown menu will be used on mobile
  */
  renderDecoration?: () => ReactNode;
}

export interface DropdownChildrenProps extends ButtonProps {
  tabIndex?: number;
}

export interface DropdownProps {
  currentValue: string;
  options: DropdownSelectMenuOption[];
  isOpen?: boolean;
  yOffset?: number;
  xOffset?: number;
  rightAligned?: boolean;
  topAligned?: boolean;
  optionalDescription?: string;
  onDropdownOpen?: (opened: boolean) => void;
  handleItemSelected?: (option: string) => void;
  id?: string;
}

export const DropdownSelectMenu: React.FunctionComponent<DropdownProps> = ({
  currentValue,
  options,
  handleItemSelected,
  isOpen,
  yOffset = 15,
  xOffset = 0,
  rightAligned,
  topAligned,
  optionalDescription,
  onDropdownOpen,
  children,
  ...rest
}) => {
  const parentRef = useRef<HTMLDivElement>(null);
  const hasDecoration = (options ?? []).some((option) => !isNil(option.renderDecoration));

  return (
    <Container ref={parentRef} {...rest}>
      {isMobile && !hasDecoration ? (
        <DropdownSelectMenuMobile
          currentValue={currentValue}
          options={options}
          handleItemSelected={handleItemSelected}
          optionalDescription={optionalDescription}
          onDropdownOpen={onDropdownOpen}
        >
          {children}
        </DropdownSelectMenuMobile>
      ) : (
        <DropdownSelectMenuDesktop
          parentRef={parentRef}
          currentValue={currentValue}
          options={options}
          handleItemSelected={handleItemSelected}
          isOpen={isOpen}
          yOffset={yOffset}
          xOffset={xOffset}
          rightAligned={rightAligned}
          topAligned={topAligned}
          optionalDescription={optionalDescription}
          onDropdownOpen={onDropdownOpen}
        >
          {children}
        </DropdownSelectMenuDesktop>
      )}
    </Container>
  );
};

const Container = styled.div`
  ${ColumnStyle};
  & select {
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    border: 0 !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    text-overflow: '';
    text-indent: 0.01px;
    text-align: left;
  }

  & select:focus {
    outline-color: transparent;
  }
`;



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/ui/form/dropdown-select-menu.component.tsx